// @flow

export default function firebaseMessaging(state = { token: null }, action) {

  switch (action.type) {
    case "PRESERVE_FIREBASE_TOKEN":
      console.log(action);
      return { token: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducer/firebaseMessaging.js